const ButtonComponent = ({ formikData }) => {
  let startURL =
    formikData?.custom_properties?.buttonInfoUrl?.split('://')?.length;
  const color =
    formikData?.custom_properties?.buttonColor || 'var(--primary-color)';

  const hexToRgb = inputColor => {
    if (inputColor.startsWith('#')) {
      const hex = inputColor.replace('#', '');
      return [
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16),
      ];
    }
    if (/^[0-9a-fA-F]{6}$/.test(inputColor)) {
      return [
        parseInt(inputColor.slice(0, 2), 16),
        parseInt(inputColor.slice(2, 4), 16),
        parseInt(inputColor.slice(4, 6), 16),
      ];
    }
    if (inputColor.startsWith('rgb')) {
      return inputColor.match(/\d+/g).slice(0, 3).map(Number);
    }

    return [130, 214, 231];
  };
  const rgb = hexToRgb(color);
  const cardModeStyles = {
    background: `
    linear-gradient(
      135deg,
      rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.9),
      rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.05)
    )
  `,
    color: formikData?.custom_properties?.buttonTextColor,

    boxShadow: `0 4px 8px rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.3)`,
    cursor: 'pointer',
    textAlign: 'center',
    fontWeight: 600,

    transition: 'all 0.2s ease-in-out',
    height: '20%',
    justifySelf: 'center',
  };

  return (
    <div
      onClick={() =>
        [
          'readOnlyWidget',
          'tabularWidget',
          'routingWidget',
          'dashboardWidget',
        ].includes(formikData?.custom_properties?.buttonWidgetType)
          ? false
          : formikData?.custom_properties?.openIn?.code == 'new-tab'
            ? window.open(
                startURL > 1
                  ? formikData?.custom_properties?.buttonInfoUrl
                  : `https://${formikData?.custom_properties?.buttonInfoUrl}`
              )
            : (window.location.href = startURL
                ? formikData?.custom_properties?.buttonInfoUrl
                : `https://${formikData?.custom_properties?.buttonInfoUrl}`)
      }
      style={cardModeStyles}
      className="border-round-lg p-4 col-6 flex align-items-center justify-content-center"
    >
      {formikData?.widget_name || ''}
    </div>
  );
};
export default ButtonComponent;
